var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('bottom-sheet', _vm._b({
    attrs: {
      "title": "마이스펙 이력 인쇄하기",
      "fullscreen": "",
      "persistent": "",
      "maxWidth": "100%",
      "needsLogin": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var attrs = _ref.attrs,
          on = _ref.on;
        return [_vm._t("activator", null, null, {
          attrs: attrs,
          on: on
        })];
      }
    }], null, true),
    model: {
      value: _vm.shows,
      callback: function callback($$v) {
        _vm.shows = $$v;
      },
      expression: "shows"
    }
  }, 'bottom-sheet', {
    width: _vm.width
  }, false), [_c('v-layout', {
    class: {
      'bottom-sheet__contents h-100': !_vm.isPrinting
    },
    attrs: {
      "column": "",
      "justify-center": ""
    }
  }, [_c('application-certification', _vm._b({
    attrs: {
      "id": "print-target"
    }
  }, 'application-certification', {
    value: _vm.value
  }, false)), _c('v-card-actions', {
    staticClass: "v-btn-group",
    attrs: {
      "id": "print-action"
    }
  }, [_c('v-btn', {
    staticClass: "min-w-140px min-w-lg-160px",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.print
    }
  }, [_vm._v("인쇄하기")])], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }